import useImpersonateEventHandler from "@src/common/eventHandlers/useImpersonateEventHandler";
import { setImpersonateUser } from "@src/common/helpers/impersonatedUser";
import routesPaths from "@src/modules/Routing/routesPaths";
import Button from "@src/modules/shared/components/Button";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

const ImpersonationBadge: FunctionComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [impersonatedUser] = useImpersonateEventHandler();

  const stopImpersonation: () => void = () => {
    setImpersonateUser(null);

    if (location.pathname === routesPaths.HOME) {
      window.location.reload();
    } else {
      history.push(routesPaths.HOME);
    }
  };

  if (impersonatedUser === null) return null;

  return <Button onClick={stopImpersonation}>{t("Stop impersonation")}</Button>;
};

export default ImpersonationBadge;
